import { Action } from "@ngrx/store";

import { ValidityState } from "./state";

export type Actions = Update;

export class Update implements Action {
    static readonly type = "validity/update";
    readonly type = Update.type;

    constructor(public validity: ValidityState) {}
}
